import React from 'react';

import { JiraIcon } from '@atlaskit/logo';

import { Products } from '../../constants';
import type { FallbackUrl } from '../../types';
import { useAppGlobalShortcutLinkItem } from '../../utils/use-app-global-shortcut-link-item';

import { messages } from './messages';

const icon = <JiraIcon size="xsmall" shouldUseNewLogoDesign />;

export const useJira = (fallbackUrl: FallbackUrl) =>
	useAppGlobalShortcutLinkItem(icon, messages.label, fallbackUrl, {
		apsKey: Products.JIRA_SOFTWARE,
	});
